// @ts-strict-ignore
import type {Section} from 'common/components/items-menu/types';
import {DateRangeType, RelativeDate} from 'common/types/reports/bookmark';

import {DateRange} from './date-range';
import {TimeUnit} from './types';
import {DATE_RANGE_TYPE_DISPLAY_NAMES, TIME_COMPARISON_OPTION_LABELS, TIME_COMPARISON_OPTIONS} from './presets';
/*
 * This class is used to support the Time Comparison Picker.
 */
export class RelativeDateRange extends DateRange {
  public getDefaultWindow(): RelativeDate {
    return {
      unit: TimeUnit.Day,
      value: 7,
    };
  }

  public getDefaultType(): DateRangeType {
    return DateRangeType.StartsOn;
  }

  public getDateRangeTypeOptions(): DateRangeType[] {
    return [DateRangeType.StartsOn, DateRangeType.EndsOn, DateRangeType.RelativeAfter];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return [TimeUnit.Day, TimeUnit.Week, TimeUnit.Month, TimeUnit.Quarter, TimeUnit.Year];
  }

  // Time comparison picker only wants to show Starts On/Ends On but still has RelativeAfter type
  public getDateRangeTypeDisplaySections(selectedType): Section[] {
    const items = [DateRangeType.StartsOn, DateRangeType.EndsOn].map((type) => ({
      value: DATE_RANGE_TYPE_DISPLAY_NAMES[type],
      label: DATE_RANGE_TYPE_DISPLAY_NAMES[type],
      isSelected: type === selectedType,
    }));
    return [{items}];
  }

  public canUseRolling(): boolean {
    return true;
  }

  public isRolling(): boolean {
    return this.from && DateRange.isRelativeDate(this.from);
  }

  public getCalendarFromDate(): string {
    return DateRange.convertBaseDateToCalendarDate(this.from);
  }

  // These aren't normal DateRange presets, they should NOT be defined in the normal `DateRange.presets` or `DateRange.getPresetOptions()` methods.
  public static getTimeComparisonPresetOptions(): any {
    return [
      {
        label: TIME_COMPARISON_OPTION_LABELS[TimeUnit.Day],
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_DAY,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Day,
            value: 1,
          },
        },
      },
      {
        label: TIME_COMPARISON_OPTION_LABELS[TimeUnit.Week],
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_WEEK,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Week,
            value: 1,
          },
        },
      },
      {
        label: TIME_COMPARISON_OPTION_LABELS[TimeUnit.Month],
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_MONTH,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Month,
            value: 1,
          },
        },
      },
      {
        label: TIME_COMPARISON_OPTION_LABELS[TimeUnit.Quarter],
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_QUARTER,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Quarter,
            value: 1,
          },
        },
      },
      {
        label: TIME_COMPARISON_OPTION_LABELS[TimeUnit.Year],
        option: TIME_COMPARISON_OPTIONS.PREVIOUS_YEAR,
        value: {
          type: DateRangeType.RelativeAfter,
          offset: {
            unit: TimeUnit.Year,
            value: 1,
          },
        },
      },
    ];
  }
}
